import { gql } from "@apollo/client";

export const UpdateRectangleBanner = gql`
mutation UpdateRectangleBanner($idStore: ID!, $content: [contentUpdateRectangleBanner]!) {
  updateRectangleBanner(idStore: $idStore, content: $content) {
    status
  }
}
`;
